export const DEFAULT_SEL_LABEL = 'เลือกรุ่นรถ';
export const DEFAULT_IMAGE =
  'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta5ac237e4e8755fe/62df4c64df0a3871e08a41c8/lcv-compare-default.jpg';
export const MODEL_IMG_SELECTED = 'selected';
export const MODEL_IMG_NOT_SELECT = 'notSelect';

export const METATAG = {
  title: 'เปรียบเทียบรุ่นรถ - อีซูซุประเทศไทย Isuzu Thailand Official',
  description:
    'เลือกรุ่นรถที่ต้องการเปรียบเทียบรายละเอียดทางเทคนิคและอุปกรณ์ต่างๆ',
};
export const HEADLINE = {
  title: 'เปรียบเทียบรุ่นรถ',
  description:
    'เลือกรุ่นรถที่ต้องการเปรียบเทียบรายละเอียดทางเทคนิคและอุปกรณ์ต่างๆ',
};

export type ILCVIcon =
  | 'engine'
  | 'torque'
  | 'gear'
  | 'wheel'
  | 'seat'
  | 'play-arrow'
  | 'camera'
  | 'camera-360';

export interface ILCVCompareSectionItem {
  id: string;
  title: string;
  icon?: ILCVIcon;
  isBold?: boolean;
  format?: string;
}

export interface ILCVCompareSection {
  title: string;
  id: string;
  items: ILCVCompareSectionItem[];
}

export interface ILCVCompareRemark {
  title: string;
  description: string;
}

export interface ILCVCompareFeatures {
  items: ILCVCompareSection[];
}

export const LCV_COMPARE_SUMMARY: ILCVCompareSection = {
  title: 'รายละเอียดสำคัญ',
  id: 'summary',
  items: [
    { id: 'engine', title: 'เครื่องยนต์', icon: 'engine', isBold: false },
    {
      id: 'maximum_torque',
      title: 'แรงบิด',
      icon: 'torque',
      isBold: true,
    },
    { id: 'wheel', title: 'ล้อ', icon: 'wheel', isBold: true },
    {
      id: 'seat_model_material',
      title: 'วัสดุเบาะนั่ง',
      icon: 'seat',
      isBold: true,
    },
    {
      id: 'audio_system',
      title: 'ระบบเครื่องเสียง',
      icon: 'play-arrow',
      isBold: true,
    },
    {
      id: 'has_rear_view_camera',
      title: 'กล้องมองหลังขณะถอย',
      icon: 'camera',
      isBold: false,
    },
    {
      id: 'has_360_camera',
      title: 'กล้องมองรอบคัน 360 องศา พร้อมมุมมองแบบ3มิติ',
      icon: 'camera-360',
      isBold: false,
    },
  ],
};

export const LCV_COMPARE_FEATURES: ILCVCompareFeatures = {
  items: [
    {
      title: 'เครื่องยนต์',
      id: 'technical_engine',
      items: [
        { id: 'model', title: 'รุ่น' },
        { id: 'type', title: 'แบบ' },
        { id: 'engine_displacement', title: 'ความจุกระบอกสูบ (ซีซี)' },
        {
          id: 'bore_width_stroke',
          title: 'ความกว้างกระบอกสูบ x ช่วงชัก (มม.)',
        },
        { id: 'compression_ratio', title: 'อัตราส่วนกำลังอัด (ต่อ 1)' },
        {
          id: 'maximum_power',
          title: 'กำลังสูงสุด กิโลวัตต์ (แรงม้า) / รอบต่อนาที',
        },
        {
          id: 'maximum_torque',
          title: 'แรงบิดสูงสุด (นิวตัน-เมตร / รอบต่อนาที)',
        },
        { id: 'iss_system', title: 'ระบบ ISS (Idling Stop / Start System)' },
        { id: 'fuel', title: 'น้ำมันเชื้อเพลิง' },
        { id: 'fuel_tank_capacity', title: 'ความจุถังน้ำมัน (ลิตร)' },
      ],
    },
    {
      title: 'ระบบส่งกำลัง',
      id: 'technical_transmission_system',
      items: [
        { id: 'drive_system', title: 'ระบบขับเคลื่อน' },
        { id: 'clutch', title: 'คลัตช์' },
        { id: 'transmission_type', title: 'ระบบเกียร์' },
        { id: 'gear1', title: 'อัตราทดเกียร์ 1', format: 'gear' },
        { id: 'gear2', title: 'อัตราทดเกียร์ 2', format: 'gear' },
        { id: 'gear3', title: 'อัตราทดเกียร์ 3', format: 'gear' },
        { id: 'gear4', title: 'อัตราทดเกียร์ 4', format: 'gear' },
        { id: 'gear5', title: 'อัตราทดเกียร์ 5', format: 'gear' },
        { id: 'gear6', title: 'อัตราทดเกียร์ 6', format: 'gear' },
        { id: 'gear7', title: 'อัตราทดเกียร์ 7', format: 'gear' },
        { id: 'gear8', title: 'อัตราทดเกียร์ 8', format: 'gear' },
        { id: 'reverse_gear', title: 'อัตราทดเกียร์ถอยหลัง', format: 'gear' },
        { id: 'final_gear_ratio', title: 'อัตราทดเฟืองท้าย', format: 'gear' },
        { id: 'transfer_gear_ratio', title: 'อัตราทดเกียร์ 4L/4H' },
        {
          id: 'has_rough_terrain_mode_system',
          title: 'ระบบ Rough Terrain Mode',
        },
        {
          id: 'has_differential_gear_lock',
          title: 'ระบบ Differential lock ที่เฟืองท้าย',
        },
      ],
    },
    {
      title: 'ระบบพวงมาลัย',
      id: 'technical_steering_system',
      items: [
        { id: 'type', title: 'ชนิด' },
        {
          id: 'minimum_turning_radius',
          title: 'รัศมีวงเลี้ยวแคบสุด (เมตร)',
          format: 'steering',
        },
      ],
    },
    {
      title: 'ระบบเบรก',
      id: 'technical_brake_system',
      items: [
        { id: 'front', title: 'หน้า' },
        { id: 'rear', title: 'หลัง' },
      ],
    },
    {
      title: 'ระบบกันสะเทือน',
      id: 'technical_suspension_system',
      items: [
        { id: 'front', title: 'หน้า' },
        { id: 'rear', title: 'หลัง' },
      ],
    },
    {
      title: 'ล้อและยาง',
      id: 'technical_wheels_tires',
      items: [
        { id: 'wheel', title: 'ล้อ' },
        { id: 'tire_size', title: 'ขนาดยาง' },
        { id: 'spare_tires', title: 'ยางอะไหล่' },
      ],
    },
    {
      title: 'มิติและความจุ',
      id: 'technical_dimension_capacity',
      items: [
        { id: 'vehicle_dimension', title: 'มิติตัวรถ ยาว x กว้าง x สูง (มม.)' },
        { id: 'cargo_dimension', title: 'มิติกระบะ ยาว x กว้าง x สูง (มม.)' },
        { id: 'wheelbase', title: 'ฐานล้อ (มม.)' },
        { id: 'front_rear_tread', title: 'ความกว้างช่วงล้อหน้า / หลัง (มม.)' },
        {
          id: 'minimum_ground_clearance',
          title: 'ความสูงใต้ท้องรถ (ที่เสื้อเพลาท้าย, มม.)',
        },
        { id: 'approximate_vehicle_weight', title: 'น้ำหนักรถโดยประมาณ (กก.)' },
      ],
    },
    {
      title: 'อุปกรณ์ภายนอก',
      id: 'equipment_exterior',
      items: [
        { id: 'headlights', title: 'ไฟหน้า' },
        {
          id: 'headlights_leveling_system',
          title: 'ระบบปรับระดับไฟหน้าสูง - ต่ำ',
        },
        { id: 'has_follow_me_home', title: 'ระบบไฟหน้า Follow me home' },
        {
          id: 'has_turn_off_automatic_headlights',
          title: 'ระบบเปิด-ปิดไฟหน้าอัตโนมัติ',
        },
        { id: 'front_fog_lights', title: 'ไฟตัดหมอกหน้า' },
        { id: 'taillights', title: 'ไฟท้าย' },
        { id: 'front_grille', title: 'กระจังหน้า' },
        { id: 'front_bumper', title: 'กันชนหน้า' },
        { id: 'side_mirror', title: 'กระจกมองข้าง' },
        { id: 'door_handle', title: 'มือเปิดประตู' },
        { id: 'chrome_mirror_edge', title: 'คิ้วขอบกระจก' },
        { id: 'b_pillar', title: 'B-Pillar ตกแต่งด้วย Blackout Film' },
        { id: 'side_steps', title: 'บันไดข้าง' },
        { id: 'rear', title: 'กันชนท้าย' },
        { id: 'has_two_tone_rear_spoiler', title: 'สปอยเลอร์หลัง' },
        { id: 'antenna', title: 'เสาอากาศ' },
        { id: 'windshield', title: 'กระจกบังลมหน้า' },
        { id: 'front_wiper', title: 'ที่ปัดน้ำฝนด้านหน้า' },
        { id: 'rear_wiper', title: 'ที่ปัดน้ำฝนด้านหลัง' },
        { id: 'has_automatic_wiper_system', title: 'ระบบปัดน้ำฝนอัตโนมัติ' },
        { id: 'has_black_roof', title: 'Black Roof' },
        { id: 'roof_trim', title: 'คิ้วหลังคา' },
        { id: 'has_roof_rail', title: 'ราวหลังคา' },
        {
          id: 'step_sensor',
          title: 'ประตูท้ายเปิด-ปิดด้วยระบบไฟฟ้า แบบ Step Sensor',
        },
        { id: 'decoration_set', title: 'ชุดตกแต่ง' },
        { id: 'xseries_on_rear', title: 'สัญลักษณ์ X-Series ที่ฝากระบะท้าย' },
        { id: 'xseries_on_fender', title: 'สัญลักษณ์ X สีแดงที่ Fender' },
        {
          id: 'rs_sign',
          title: 'สัญลักษณ์ RS ที่แก้มข้างสองข้าง,ฝาท้ายด้านขวา',
        },
      ],
    },
    {
      title: 'อุปกรณ์ภายใน',
      id: 'equipment_interior',
      items: [
        { id: 'gauge', title: 'มาตรวัด' },
        {
          id: 'has_gear_shift_indicating_system',
          title: 'ระบบแนะนำการเปลี่ยนเกียร์ GSI (Genius Sport Shift)',
        },
        { id: 'steering_wheel_material', title: 'พวงมาลัย' },
        { id: 'steering_wheel', title: 'การปรับระดับพวงมาลัย' },
        {
          id: 'has_audio_control_on_steering_wheel',
          title: 'สวิตซ์ควบคุมเครื่องเสียงที่พวงมาลัย',
        },
        {
          id: 'has_cruise_control',
          title: 'ระบบควบคุมความเร็วอัตโนมัติ (Cruise Control)',
        },
        {
          id: 'has_paddle_shift',
          title: 'ระบบควบคุมการเปลี่ยนเกียร์ที่พวงมาลัย (Paddle Shift)',
        },
        { id: 'front_console_decoration', title: 'การตกแต่งคอนโซลหน้า' },
        {
          id: 'multipurpose_holder',
          title: 'ที่วางของอเนกประสงค์บนคอนโซลหน้า',
        },
        { id: 'center_console', title: 'คอนโซลกลาง' },
        { id: 'door_panel_decoration', title: 'ชุดตกแต่งแผงประตู' },
        { id: 'inner_door_opening_handle', title: 'มือเปิดประตูด้านใน' },
        { id: 'power_windows', title: 'กระจกไฟฟ้า' },
        { id: 'central_locking', title: 'เซ็นทรัลล็อก' },
        { id: 'integrated_remote_keyless', title: 'กุญแจรีโมท' },
        {
          id: 'isuzu_genius_entry_key_and_push_start',
          title: 'ระบบสตาร์ทแบบ Push Start',
        },
        { id: 'remote_engine_start', title: 'ระบบ Remote Engine Start' },
        { id: 'audio_system', title: 'ระบบเครื่องเสียง' },
        {
          id: 'telephone_connection',
          title: 'ระบบเชื่อมต่อโทรศัพท์ และการเล่นเพลง',
        },
        { id: 'number_of_speakers', title: 'ลำโพง' },
        { id: 'air_conditioning_system', title: 'ระบบปรับความเย็น' },
        { id: 'has_air_filter', title: 'แผ่นกรองระบบปรับอากาศ PM 2.5' },
        {
          id: 'has_air_vents_rear_passengers',
          title: 'ช่องแอร์สำหรับผู้โดยสารตอนหลัง',
        },
        {
          id: 'has_power_socket_12_volt',
          title: 'ช่องต่ออุปกรณ์ไฟฟ้าเสริม DC 12 โวลต์',
        },
        {
          id: 'has_additional_usb_power_outlet',
          title: 'ช่องต่ออุปกรณ์ไฟฟ้าเสริม USB Charger',
        },
        {
          id: 'has_glasses_holder_with_light',
          title: 'ที่ใส่แว่นตา พร้อมไฟส่องแผนที่ 2 ตำแหน่ง',
        },
        { id: 'sunshade', title: 'ที่บังแดด' },
        { id: 'has_interior_lamp', title: 'ไฟส่องสว่างในห้องโดยสาร' },
        {
          id: 'reading_lights_seat2',
          title: 'ไฟอ่านหนังสือสำหรับที่นั่งแถวที่ 2: 2 ตำแหน่ง',
        },
        {
          id: 'rear_luggage_light',
          title: 'ไฟส่องสว่างที่วางสัมภาระด้านท้าย',
        },
        {
          id: 'assist_ambient_light',
          title: 'INSTRUMENT PANEL ASSIST SIDE ambient light',
        },
        { id: 'foot_light', title: 'ไฟส่องเท้า' },

        { id: 'seat_model_material', title: 'วัสดุเบาะนั่ง' },
        { id: 'seat_model_the_front_can_adjusted', title: 'เบาะนั่งคู่หน้า' },
        {
          id: 'seat_model_has_document_storage_compartment',
          title: 'ช่องเก็บเอกสารหลังเบาะคู่หน้า',
        },
        {
          id: 'luggage_hanger',
          title: 'ที่แขวนสัมภาระหลังเบาะหน้า ด้านผู้โดยสาร',
        },
        { id: 'seat_model_seat2', title: 'เบาะนั่งตอน 2' },
        { id: 'seat_model_seat3', title: 'เบาะนั่งตอน 3' },
        { id: 'assist_grip', title: 'มือจับภายในรถ (Assist Grip)' },
      ],
    },
    {
      title: 'อุปกรณ์เพื่อความปลอดภัย',
      id: 'equipment_safety',
      items: [
        {
          id: 'has_led_daytime_running_light',
          title: 'ไฟส่องสว่างเวลากลางวันแบบ LED',
        },
        {
          id: 'has_led_turning_signal',
          title: 'ไฟเลี้ยวแบบ LED ที่กระจกมองข้าง',
        },
        { id: 'has_turning_signal_lights', title: 'ไฟเลี้ยวด้านข้างตัวรถ' },
        { id: 'has_3rd_brake_light', title: 'ไฟเบรกดวงที่ 3 แบบ LED' },
        { id: 'steel_beam_door', title: 'ประตูเสริมคานเหล็กเพื่อความปลอดภัย' },
        { id: 'collapsible_brake_pedal', title: 'แป้นเบรกยุบตัวได้' },
        {
          id: 'has_front_side_airbags',
          title: 'ถุงลมคู่หน้า (Dual SRS Airbags)',
        },
        { id: 'has_side_airbags', title: 'ถุงลมด้านข้าง (SRS Side Airbags)' },
        {
          id: 'has_side_curtain_airbags',
          title: 'ม่านถุงลมด้านข้าง (SRS Roof Rail Airbags)',
        },
        {
          id: 'door_unlock_on_srs_airbag',
          title: 'ระบบปลดล็อกประตูอัตโนมัติเมื่อถุงลม SRS ทำงาน',
        },
        {
          id: 'one_motion_unlock',
          title: 'ระบบปลดล็อกประตู One Motion Unlock เฉพาะด้านผู้ขับขี่',
        },
        { id: 'front_seat_belt', title: 'เข็มขัดนิรภัยเบาะคู่หน้า' },
        { id: 'seat_belt2', title: 'เข็มขัดนิรภัยเบาะตอน 2' },
        { id: 'seat_belt3', title: 'เข็มขัดนิรภัยเบาะตอน 3' },
        {
          id: 'seat_belt_reminder',
          title: 'ระบบเตือนคาดเข็มขัดนิรภัยผู้โดยสารคู่หน้า',
        },
        {
          id: 'has_isofix_mounting_points',
          title: 'จุดยึด ISOFIX ที่เบาะตอน 2',
        },
        { id: 'has_rear_window_defogger', title: 'ไล่ฝ้ากระจกหลัง' },
        {
          id: 'rear_view_mirror_with_anti_glare',
          title: 'กระจกมองหลังปรับแบบปรับลดแสงสะท้อนได้',
        },
        { id: 'has_rear_view_camera', title: 'กล้องมองภาพด้านหลังขณะถอยจอด' },
        {
          id: 'has_360_camera',
          title: 'กล้องมองรอบคัน 360 องศา พร้อมมุมมองแบบ3มิติ',
        },
        {
          id: 'has_electric_hand_brake',
          title: 'ระบบเบรคมือไฟฟ้า พร้อมระบบ Auto Hold',
        },
        {
          id: 'has_abs_with_ebd_and_ba',
          title: 'ระบบป้องกันล้อล็อก ABS พร้อม EBD และ BA',
        },
        {
          id: 'has_brake_override_system',
          title: 'ระบบลดกำลังเครื่องยนต์เพื่อช่วยเบรก BOS',
        },
        {
          id: 'has_esc_electronic_stability_control_system',
          title: 'ระบบควบคุมการทรงตัวอัตโนมัติ ESC',
        },
        {
          id: 'has_tcs_traction_control_system',
          title: 'ระบบป้องกันล้อหมุนฟรีขณะออกตัว TCS',
        },
        {
          id: 'has_hsa_hill_start_assist_system',
          title: 'ระบบช่วยออกตัวบนทางลาดชัน HSA',
        },
        {
          id: 'has_hdc_hill_descent_control_system',
          title: 'ระบบควบคุมความเร็วขณะลงทางลาดชัน HDC',
        },
        {
          id: 'has_tsc',
          title: 'ระบบควบคุมการส่ายของส่วนพ่วงท้าย TSC (Trailer Sway Control)',
        },
        {
          id: 'has_bsm_blind_spot_monitoring_system',
          title: 'ระบบช่วยเตือนมุมอับสายตาที่กระจกมองข้าง BSM',
        },
        {
          id: 'has_rcta_rctb',
          title: 'ระบบช่วยเตือนขณะถอยรถและระบบช่วยเบรกขณะถอยรถ RCTA & RCTB',
        },
        {
          id: 'has_attension_assist',
          title: 'ระบบช่วยเตือนอาการเหนื่อยล้าขณะขับขี่ (Attention assist)',
        },
        {
          id: 'has_8_points_parking_sensors',
          title: 'เซ็นเซอร์ช่วยกะระยะหน้า 4 จุด และหลัง 4 จุด',
        },
        {
          id: 'has_ess_emergency_signal_system',
          title: 'สัญญาณไฟฉุกเฉินอัตโนมัติขณะเบรกกระทันหัน ESS',
        },
        {
          id: 'has_walk_away_auto_door_lock',
          title:
            'ระบบล็อกรถอัตโนมัติเมื่อกุญแจรีโมทอยู่ห่างจากตัวรถ (Walk Away Auto Lock)',
        },
        { id: 'has_anti_theft_alarm', title: 'สัญญาณกันขโมย' },
        {
          id: 'warning_turn_off_headlights',
          title: 'สัญญาณเสียงเตือนปิดไฟหน้า',
        },
        { id: 'alarm_forget_key', title: 'สัญญาณเสียงเตือนลืมกุญแจ' },
        {
          id: 'has_fcw',
          title:
            'ระบบแจ้งเตือนก่อนการชนด้านหน้า Forward Collision Warning (FCW)',
        },
        {
          id: 'has_aeb',
          title: 'ระบบเบรคฉุกเฉินอัตโนมัติ Autonomous Emergency Braking (AEB)',
        },
        {
          id: 'has_ldw',
          title: 'ระบบแจ้งเตือนออกนอกเลน Lane Departure Warning (LDW)',
        },
        {
          id: 'has_ldp',
          title:
            'ระบบช่วยควบคุมรถไม่ให้ออกนอกเลน Lane Departure Prevention (LDP)',
        },
        {
          id: 'has_elk',
          title:
            'ระบบช่วยควบคุมรถให้อยู่ในเลนในสถานการณ์ฉุกเฉิน Emergency Lane Keeping (ELK)',
        },
        {
          id: 'has_lkas',
          title: 'ระบบช่วยควบคุมรถให้อยู่ในเลน Lane Keep Assist System (LKAS)',
        },
        {
          id: 'has_tja',
          title:
            'ระบบช่วยควบคุมทิศทางของรถตามรถคันหน้า Traffic Jam Assist (TJA)',
        },
        {
          id: 'has_pmm',
          title:
            'ระบบตัดกำลังเครื่องยนต์เมื่อเหยียบคันเร่งผิดพลาด Pedal Misapplication Mitigation (PMM)',
        },
        {
          id: 'has_msl',
          title:
            'ระบบตั้งค่าจำกัดความเร็วสูงสุดด้วยตัวเอง Manual Speed Limiter (MSL)',
        },
        {
          id: 'has_ahb',
          title: 'ระบบควบคุมไฟสูงอัตโนมัติ Automatic High Beam (AHB)',
        },
        {
          id: 'has_mcb',
          title:
            'ระบบเบรคอัตโนมัติหลังการเกิดอุบัติเหตุ Multi-Collision Brake (MCB)',
        },
        {
          id: 'has_turn_assist',
          title:
            'ระบบเบรกฉุกเฉินอัตโนมัติเมื่อมีรถสวนทางขณะเลี้ยวขวา Turn Assist with AEB',
        },
      ],
    },
  ],
};

export const LCV_COMPARE_REMARK: ILCVCompareRemark = {
  title: 'หมายเหตุ',
  description: `
    <ul>
      <li>ราคาที่ปรากฎเป็นราคาขายปลีกแนะนำเท่านั้น รุ่นที่ปรากฎในภาพอาจแตกต่างจากรูปจริง โปรดศึกษารายละเอียดรุ่นรถและอุปกรณ์จากตารางด้านบน</li>
      <li>รายละเอียดต่างๆ อาจมีการเปลี่ยนแปลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</li>
      <li>สีที่ปรากฏในภาพอาจแตกต่างจากสีจริง</li>
      <li>อุปกรณ์มาตรฐานไม่รวมอุปกรณ์ตกแต่งเสริม</li>
      <li>ก่อนใช้งานโปรดศึกษาวิธีการใช้งานจากคู่มือการใช้รถและคู่มือการใช้อุปกรณ์เสริมโดยละเอียด เพื่อความปลอดภัยและประสิทธิภาพในการใช้งาน</li>
      <li>ระบบ Apple CarPlay เป็นลิขสิทธิ์ของ Apple Inc. ซึ่งรองรับการใช้งานระบบและอุปกรณ์ตามที่ระบุไว้ใน <a href="http://www.apple.com/th/ios/carplay" target="_blank">Apple CarPlay</a>
    </ul>
  `,
};
